import { createField } from "./sequestrate-info.section";
import store from "../../../../../../store";
import lodash from "lodash";
import { createForm as createFormAddress } from "../../../../../../components/address/address.logic";

export const initForm = ({ props, data, refs }) => {
    const key = props.dataKey;
    const itemKey = props.itemKey;
    const isLoading = props.isLoading;
    data.fields = createField({ props, data, refs, key, itemKey, isLoading });
};

export const createForm = () => {
    return {
            sequestrateDatetime: null,
            refOperation: null,
            manufactureDate: null,
            manufactureExpireDate: null,
            manufacturer: null,
            importer: null,
            distributor: null,
            size: null,
            refSizeUnit: null,
            qty: null,
            refQtyUnit: null,
    };
};

export const initDefaultForm = ({ data, key }) => {
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    if (!model.id) {
        model.refDepartment = modelRef.refReleaseTemp?.refDepartment;
        model.refUserCompany = modelRef.refReleaseTemp?.refUserCompany;
        model.refUser = modelRef.refReleaseTemp?.refUser;
        model.refOfficer = lodash.cloneDeep(store.state.resource.auth.info?.user);
    }
    if (!model?.addresses?.length) {
        model.addresses = [{ ...createFormAddress(), refAddressType: data.addressTypes?.find(d => d.key === "1") }];
    }
    return model;
}